import { colors } from "@material-ui/core";
import React from "react";
import toast from "react-hot-toast";

import { makeRequest } from "@/util";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { FacebookIcon } from "@/components/icons/themes/color";
import { MetaAudiencesTermsOfServiceRow } from "./MetaOAuth/MetaAudiencesTermsOfServiceRow";
import { IdentityMatchingRow } from "../shared/IdentityMatchingRow/IdentityMatchingRow";

// Meta Insights is the new name in the UI. The backend still uses "Meta Ad Performance".
const META_OAUTH_INTEGRATION_NAME = "meta-ad-performance";

const AdAccountIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["adAccountID"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const AdAccountIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "adAccountID" in settings;

  return (
    <DestinationConfigRow
      name="Ad Account ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = () => {
  return null;
};

const OAuthRow = ({ existingConfig, destination }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const disableRow = !existingConfig.id;

  const onOpenConfigModal = () => {
    let integrationName = destination.slug;
    // Meta Insights is the new name in the UI. The backend still uses "Meta Ad Performance".
    if (destination.slug === "meta-insights") {
      integrationName = META_OAUTH_INTEGRATION_NAME;
    }
    makeRequest("get_oauth_url", {
      integration_name: integrationName,
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <div
      className="bg-thirdParty-facebookBlue font-semi-bold inline-block w-auto cursor-pointer rounded px-2 py-1 text-white"
      onClick={onOpenConfigModal}
    >
      <FacebookIcon
        className="position mr-2 fill-white"
        height="2em"
        style={{ top: -2 }}
      />
      {oauthConfigured ? "Reconnect" : "Login With Facebook"}
    </div>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      disabled={disableRow}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
};

const AD_ACCOUNT_ID = "AD_ACCOUNT_ID";
const OAUTH = "OAUTH";
const TERMS = "TERMS";
const IDENTITY_MATCHING = "IDENTITY_MATCHING";

const Rows = {
  [AD_ACCOUNT_ID]: AdAccountIDRow,
  [OAUTH]: OAuthRow,
  [TERMS]: MetaAudiencesTermsOfServiceRow,
  [IDENTITY_MATCHING]: IdentityMatchingRow,
};

const Modals = {
  [AD_ACCOUNT_ID]: AdAccountIDModal,
  [OAUTH]: OAuthModal,
  [TERMS]: null,
};

const RowOrder = [AD_ACCOUNT_ID, OAUTH, TERMS, IDENTITY_MATCHING];

const config = {
  Rows,
  RowOrder,
  Modals,
};
export default config;
